




























































































































































































































































import { i18n } from "../scripts/helpers/translation/i18n";
import { Trans } from "../scripts/helpers/translation/translation";
import Vue from "vue";

// Declare the global variable UC_UI used by Usercentrics.
declare const UC_UI: any;

export default Vue.extend({
    name: "Footer",

    computed: {
        currentLanguage: function(): string {
            return Trans.currentLocale;
        },
        activeRoute: function(): string {
            return this.$route.name as string;
        },
        priceMapUrl: function(): string {
            return process.env.VUE_APP_IMMOWEB_PRICE_MAP_URL + "/" + this.currentLanguage + "?utm_source=website&utm_medium=referral&utm_campaign=footer";
        },
        insurancesURL: function(): string {
            switch(this.currentLanguage) {
            case "fr": return "https://protect.immoweb.be/fr?utm_source=website&utm_medium=referral&utm_campaign=menu";
            case "en": return "https://protect.immoweb.be/?utm_source=website&utm_medium=referral&utm_campaign=menu";
            case "nl": return "https://protect.immoweb.be/nl?utm_source=website&utm_medium=referral&utm_campaign=menu";
            default: return "https://protect.immoweb.be/?utm_source=website&utm_medium=referral&utm_campaign=menu";
            }
        },

        paymentMethods: function(): string[] {
            return ["Bancontact", "Visa", "Mastercard"];
        }
    },
    methods: {
        getUrl: function(key: string) {
            return process.env.VUE_APP_IMMOWEB_URL + i18n.t(key).toString();
        },
        handleCookieSettingsClick: function () {
            const currentLanguage = this.currentLanguage;
            if (typeof UC_UI !== "undefined") {
                UC_UI.updateLanguage(currentLanguage);
                UC_UI.showSecondLayer();
            } else {
                console.warn("UC_UI is not defined");
            }
        }
    },
});
